/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_ChatInputs */

const en_tut_sc_chat = /** @type {(inputs: Tut_Sc_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Chat`)
};

const id_tut_sc_chat = /** @type {(inputs: Tut_Sc_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Chat`)
};

/**
* | output |
* | --- |
* | "Jump to Chat" |
*
* @param {Tut_Sc_ChatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_chat = /** @type {((inputs?: Tut_Sc_ChatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_ChatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_chat(inputs)
	return en_tut_sc_chat(inputs)
});